import React, { useRef, useState } from 'react';
import './App.css';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

firebase.initializeApp({
  apiKey: 'AIzaSyAJ1l6812CPlR-ELjKHG-7ikiP_O5uby2s',
  authDomain: 'global-chat-2021.firebaseapp.com',
  projectId: 'global-chat-2021',
  storageBucket: 'global-chat-2021.appspot.com',
  messagingSenderId: '42507669828',
  appId: '1:42507669828:web:76e12bb27227b638030711',
  measurementId: 'G-815QSMT1FK',
});

const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {
  const [user] = useAuthState(auth);

  return (
    <div className="App">
      <header>
        <h1>Global Chat 👋</h1>
        <SignOut />
      </header>

      <section>{user ? <ChatRoom /> : <SignIn />}</section>
    </div>
  );
}

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  };

  return (
    <>
      <button className="sign-in" onClick={signInWithGoogle}>
        Sign in with Google
      </button>
      {/* <p>
        Do not violate the community guidelines or you will be banned for life!
      </p> */}
    </>
  );
}

function SignOut() {
  return (
    auth.currentUser && (
      <a className="sign-out" onClick={() => auth.signOut()}>
        <img src="https://cdn.iconscout.com/icon/premium/png-256-thumb/signout-1-561714.png" />
      </a>
    )
  );
}

function ChatRoom() {
  const dummy = useRef();
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(1000);

  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');

  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL,
    });

    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <main>
        {messages &&
          messages.map((msg) => <ChatMessage key={msg.id} message={msg} />)}

        <span ref={dummy}></span>
      </main>

      <form onSubmit={sendMessage}>
        <input
          value={formValue}
          onChange={(e) => setFormValue(e.target.value)}
          placeholder="HappyNewYear2021"
        />

        <button type="submit" disabled={!formValue}>
          📡
        </button>
      </form>
    </>
  );
}

function ChatMessage(props) {
  const { text, uid, photoURL } = props.message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  return (
    <>
      <div className={`message ${messageClass}`}>
        <img
          src={photoURL || 'https://www.w3schools.com/w3images/avatar6.png'}
        />
        <p>{text}</p>
      </div>
    </>
  );
}

export default App;
